import type { ReportAnswers } from '../../../../report/CustomerReport';
import { isAnswerValueSelected } from '../../../../report/getQuestion';
import { PowerIssue } from '../../../../report/questions/problemType/PowerIssue';
import { ReportQuestion } from '../../../../report/questions/ReportQuestion';
import type { PremiseDataDocument } from '../../../interfaces/containers/premises/PremiseData';
import { ApplianceTypes } from './ApplianceTypes';
import { isPowerIssue } from './isPowerIssue';

export function isOutage(answers: ReportAnswers, masterData: PremiseDataDocument): boolean {
	// Must have active electric service to be an outage
	if (!isPowerIssue(answers, masterData)) {
		return false;
	}

	// TODO: need a better alternative to this that doesn't send PowerIssue.Outage when we know it's partial power
	const onlyInterruptible = isAnswerValueSelected(
		answers,
		ReportQuestion.AppliancesWithoutPower,
		ApplianceTypes.OnlyWaterHeaterOrAirConditioner,
	);
	if (onlyInterruptible) {
		return false;
	}

	return isAnswerValueSelected(answers, ReportQuestion.PowerIssue, PowerIssue.Outage);
}
